// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7696b82e","77":"ef8ec3c5","282":"baba273f","294":"00b39a4d","447":"4b01a078","622":"96e9289f","825":"bd74b037","829":"7063da4c","978":"62a9dd32"}[chunkId] + ".chunk.js";
};